<template>
  <div class="main-content chart-group-setting">
    <div class="setting-left">
      <div
        v-for="(item, index) in groupingList"
        :key="index"
        class="nav-list"
      >
        <div class="item" :class="{'setColor': selectItemId === item.uuid}" @click="selectItem(item, item.uuid)">
          <i :class="{ 'rotatingShow': item.open, 'rotatingHide': !item.open }" class="el-icon-arrow-right" />
          <span>{{ `${item.name}(${item.charts.length})` }}</span>
        </div>
        <div v-show="item.open" class="children-item" :class="{'border-bottom':item.charts.length > 0}">
          <span v-for="(chartItem, chartIndex) in item.charts" :key="chartIndex" :class="{'setColor': chartItemId === chartItem.uuid }" @click="selectChart(chartItem, chartIndex)">{{ chartItem.name }}</span>
        </div>
      </div>
    </div>
    <div class="setting-right">
      <div class="setting-right-operation">
        <el-button type="primary" @click="newGrouping">{{ $t('BusinessIntelligence.chartGroupSetting.newGrouping') }}</el-button>
        <el-button type="primary" :disabled="disabled" @click="editGrouping">{{ $t('BusinessIntelligence.common.edit') }}</el-button>
        <el-button type="danger" :disabled="deleteShow || !isCheck" @click="deletes">{{ $t('BusinessIntelligence.chartGroupSetting.delete') }}</el-button>
      </div>
      <div v-show="editGroupingShow" class="setting-right-content">
        <div class="edit-button">
          <el-button type="primary" @click="groupingSave">{{ $t('BusinessIntelligence.common.save') }}</el-button>
          <el-button type="primary" @click="editCancel">{{ $t('BusinessIntelligence.common.cancel') }}</el-button>
        </div>
        <div class="ag-form">
          <span class="title">{{ title }}</span>
          <div class="ag-form-content">
            <div class="edit-form">
              <el-form :model="form" label-width="80px" label-position="left">
                <el-form-item :label="$t('BusinessIntelligence.chartGroupSetting.order')">
                  <el-input-number v-model="form.rankIndex" controls-position="right" :min="0" />
                </el-form-item>
                <el-form-item :label="$t('BusinessIntelligence.chartGroupSetting.groupName')">
                  <el-input v-model="form.name" :disabled="editName" />
                </el-form-item>
                <el-form-item :label="$t('BusinessIntelligence.chartGroupSetting.remark')">
                  <el-input v-model="form.remark" :rows="5" type="textarea" />
                </el-form-item>
              </el-form>
            </div>
            <div class="chart-form" style="flex:1;">
              <span style="font-size:14px;">{{ $t('BusinessIntelligence.chartGroupSetting.selectGrouping') }}</span>
              <div class="chart-form-search">
                <input v-model="searchValue" style="width:150px;" :placeholder="$t('BusinessIntelligence.chartGroupSetting.queryChartName')" class="set-input">
                <el-button type="primary" style="margin-left:10px;" @click="searchChart">{{ $t('BusinessIntelligence.common.query') }}</el-button>
              </div>
              <div style="margin-top:10px;">
                <cargo-ag-grid
                  config-module="2022090101"
                  :grid-options="gridOptions"
                  :column-defs="columnDefs"
                  :row-data="rowDataList"
                  @gridReady="params=>{gridApi=params.api}"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="editChartShow" class="setting-right-content">
        <div v-show="!isCheck" class="edit-button">
          <el-button type="primary" @click="editChartSave">{{ $t('BusinessIntelligence.common.save') }}</el-button>
          <el-button type="primary" @click="editChartCancel">{{ $t('BusinessIntelligence.common.cancel') }}</el-button>
        </div>
        <div class="ag-form" style="height:500px;width: 800px;">
          <span v-show="!isCheck" class="title">{{ $t('BusinessIntelligence.chartGroupSetting.eidtChart') }}</span>
          <span v-show="isCheck" class="title">{{ $t('BusinessIntelligence.chartGroupSetting.viewChart') }}</span>
          <div class="ag-form-content">
            <div class="edit-form">
              <el-form :model="chartForm" label-width="80px" label-position="left">
                <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceChart.chartName')">
                  <el-input v-model="chartForm.name" :disabled="isCheck" />
                </el-form-item>
                <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceChart.chartGrouping')">
                  <el-select v-model="chartForm.groupUuid" :disabled="isCheck">
                    <el-option
                      v-for="(item, index) in groupingList"
                      :key="index"
                      :label="item.name"
                      :value="item.uuid"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('BusinessIntelligence.chartGroupSetting.remark')">
                  <el-input v-model="chartForm.remark" :disabled="isCheck" :rows="5" type="textarea" />
                </el-form-item>
              </el-form>
            </div>
            <div class="chart-form">
              <span style="font-size:14px;">{{ chartForm.name }}</span>
              <div class="chart">
                <iframe
                  id="bdIframe"
                  ref="myIframe"
                  :src="chartForm.url"
                  frameborder="0"
                  allowtransparency
                  scrolling="no"
                  width="100%"
                  height="100%"
                />
                <span class="mask" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getLoading } from '@/utils/utilBaseElement'
import { groupAdd, groupModify, groupList, deleteGroup } from '@/api/sysManage/businessIntelligence/chartGroupSetting'
import { editChart } from '@/api/sysManage/businessIntelligence/businessIntelligenceChart'
import { getMyChart } from '@/api/sysManage/businessIntelligence/businessIntelligenceChart'
export default {
  name: 'ChartGroupSetting',
  data() {
    return {
      isCheck: true,
      title: '',
      selectItemId: '',
      chartItemId: '',
      deleteShow: true,
      chartData: {},
      groupData: {},
      groupingList: [],
      nameList: [],
      editChartShow: false,
      editGroupingShow: false,
      disabled: true,
      editName: false,
      form: {
        rankIndex: '',
        name: '',
        remark: '',
        charts: []
      },
      chartForm: {
        name: '',
        groupUuid: '',
        remark: ''
      },
      searchValue: '',
      loading: false,
      chartList: [],
      rowData: [],
      rowDataList: [],
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        onSelectionChanged: event => {
          this.chartList = event.api.getSelectedRows()
        }
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('BusinessIntelligence.businessIntelligenceChart.chartName'),
          field: 'name',
          width: 100
        },
        {
          headerName: this.$t('BusinessIntelligence.chartGroupSetting.currentGrouping'),
          field: 'groupName',
          width: 150
        },
        {
          headerName: this.$t('BusinessIntelligence.chartGroupSetting.chartDescription'),
          field: 'remark',
          width: 150
        }
      ]
    }
  },
  methods: {
    // 切换至图表分组设置页签时，初始化列表交互
    init() {
      this.editGroupingShow = false
      this.editChartShow = false
      this.selectItemId = ''
      this.chartItemId = ''
      this.isCheck = true
    },
    // 新增分组
    async groupAddFunc() {
      if (this.nameList.includes(this.form.name)) {
        this.$message.warning(this.$t('BusinessIntelligence.chartGroupSetting.groupNameTips'))
        return
      }
      const data = {
        name: this.form.name,
        rankIndex: this.form.rankIndex,
        remark: this.form.remark,
        charts: []
      }
      if (this.chartList.length > 0) {
        this.chartList.map((item) => {
          data.charts.push({
            chartId: item.chartId,
            uuid: item.uuid
          })
        })
      }
      this.loading = getLoading()
      const res = await groupAdd(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        this.selectItemId = this.form.uuid
        // 保存成功后，如果当前分组的图表大于0，则删除按钮置灰
        if (data.charts.length > 0) {
          this.deleteShow = true
        } else {
          this.deleteShow = false
        }
        this.editCancel()
        this.editChartShow = false
        this.getList(data.name)
        this.editGroupingShow = false
        this.$message.success(this.$t('BusinessIntelligence.common.saveSuccess'))
      }
    },
    // 获取分组列表
    async getList(name) {
      const data = {
        includeCharts: true
      }
      this.loading = getLoading()
      const res = await groupList(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        this.nameList = []
        res.data.forEach((item) => {
          item.open = false
          this.nameList.push(item.name)
        })
        this.groupingList = res.data
        if (name) {
          const arr = this.groupingList.filter((item) => {
            return name === item.name
          })
          this.groupData = arr[0]
        }
      }
    },
    // 新建分组弹窗内图表列表
    async getChartList() {
      this.loading = getLoading()
      const res = await getMyChart().finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        res.data.forEach((item) => {
          this.groupingList.filter((i) => {
            if (i.uuid === item.groupUuid) {
              item.groupName = i.name
            }
          })
        })
        this.rowData = res.data
        this.rowDataList = JSON.parse(JSON.stringify(res.data))
      }
    },
    // 新建分组右侧图表搜索
    searchChart() {
      if (this.searchValue) {
        this.rowDataList = this.rowData.filter((item) => {
          return (item.name).indexOf(this.searchValue) !== -1
        })
      } else {
        this.rowDataList = this.rowData
      }
    },
    // 新建分组按钮
    async newGrouping() {
      if (this.editGroupingShow || !this.isCheck) {
        return
      }
      this.editName = false
      this.editChartShow = false
      this.editGroupingShow = true
      this.title = this.$t('BusinessIntelligence.chartGroupSetting.addGroup')
      this.getChartList()
    },
    // 编辑窗口打开
    async editGrouping() {
      if (this.editGroupingShow || !this.isCheck) {
        return
      }
      // 编辑分组
      if (this.selectItemId !== '') {
        if (this.groupData.name === '业务图表' || this.groupData.name === '财务图表') {
          this.editName = true
        } else {
          this.editName = false
        }
        this.form = { ...this.groupData }
        this.title = this.$t('BusinessIntelligence.chartGroupSetting.editGroup')
        await this.getChartList()
        if (this.form.charts.length > 0) {
          this.gridOptions.api.forEachNode(node => {
            this.form.charts.map((item) => {
              if (node.data.chartId === item.chartId) {
                node.setSelected(true)
              }
            })
          })
        }
        this.editGroupingShow = true
      }
      // 编辑图表
      if (this.chartItemId !== '') {
        this.isCheck = false
      }
    },
    // 分组保存
    async groupingSave() {
      if (this.form.rankIndex === '') {
        this.$message.warning(this.$t('BusinessIntelligence.chartGroupSetting.rankRemind'))
        return
      }
      if (!this.form.name.trim()) {
        this.$message.warning(this.$t('BusinessIntelligence.chartGroupSetting.groupingNameRemind'))
        return
      }
      if (this.title === this.$t('BusinessIntelligence.chartGroupSetting.addGroup')) {
        this.groupAddFunc()
      }
      if (this.title === this.$t('BusinessIntelligence.chartGroupSetting.editGroup')) {
        this.editGroup()
      }
    },
    // 编辑分组接口
    async editGroup() {
      if (this.groupData.name !== this.form.name) {
        for (let i = this.nameList.length - 1; i >= 0; i--) {
          if (this.nameList[i] === this.form.name) {
            this.$message.warning(this.$t('BusinessIntelligence.chartGroupSetting.groupNameTips'))
            return
          }
        }
      }
      const data = {
        name: this.form.name,
        rankIndex: this.form.rankIndex,
        uuid: this.form.uuid,
        remark: this.form.remark,
        charts: []
      }
      if (this.chartList.length > 0) {
        this.chartList.map((item) => {
          data.charts.push({
            chartId: item.chartId,
            uuid: item.uuid
          })
        })
      }
      this.loading = getLoading()
      const res = await groupModify(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        this.selectItemId = this.form.uuid
        // 保存成功后，如果当前分组的图表大于0，则删除按钮置灰
        if (data.charts.length > 0) {
          this.deleteShow = true
        } else {
          this.deleteShow = false
        }
        this.getList(data.name)
        this.editGroupingShow = false
        this.$message.success(this.$t('BusinessIntelligence.common.saveSuccess'))
      }
    },
    // 图表编辑保存
    async editChartSave() {
      if (!this.chartForm.name.trim()) {
        this.$message.warning(this.$t('BusinessIntelligence.chartGroupSetting.chartNameRemind'))
        return
      }
      if (!this.chartForm.groupUuid) {
        this.$message.warning(this.$t('BusinessIntelligence.chartGroupSetting.chartGrouping'))
        return
      }
      const data = {
        name: this.chartForm.name,
        groupUuid: this.chartForm.groupUuid,
        chartId: this.chartForm.chartId
      }
      this.chartForm.remark ? data.remark = this.chartForm.remark : ''
      this.loading = getLoading()
      const res = await editChart(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        await this.getList()
        console.log('this.groupingList', this.groupingList)
        this.groupingList.forEach((item) => {
          if (item.uuid === res.data.groupUuid) {
            item.open = true
            this.chartItemId = res.data.uuid
          }
        })
        this.isCheck = true
        this.chartForm.name = res.data.name
        this.chartForm.remark = res.data.remark
        this.chartForm.groupUuid = res.data.groupUuid
        this.chartForm.url = this.chartData.url
        this.$message.success(this.$t('BusinessIntelligence.common.saveSuccess'))
      }
    },
    // 选中分组
    selectItem(item, uuid) {
      if (this.editGroupingShow || !this.isCheck) {
        return
      }
      this.editChartShow = false
      this.initForm = item
      this.groupData = item
      item.open = !item.open
      this.chartItemId = ''
      this.selectItemId = uuid
      this.chartData = {}
      this.disabled = false
      if (item.name !== '业务图表' && item.name !== '财务图表') {
        this.editName = false
        if (item.charts.length === 0) {
          this.deleteShow = false
        } else {
          this.deleteShow = true
        }
      } else {
        this.deleteShow = true
        this.editName = true
      }
    },
    // 选中图表
    selectChart(chartItem) {
      if (this.editGroupingShow || !this.isCheck) {
        return
      }
      this.editChartShow = true
      this.isCheck = true
      this.deleteShow = false
      this.selectItemId = ''
      this.groupData = {}
      this.chartData = JSON.parse(JSON.stringify(chartItem))
      this.chartForm = { ...chartItem }
      this.disabled = false
      this.chartItemId = chartItem.uuid
      console.log('chartItem', chartItem)
    },
    // 删除图表或分组
    async deletes() {
      if (this.editGroupingShow || !this.isCheck) {
        return
      }
      // 删除分组
      if (Object.keys(this.groupData).length !== 0) {
        const data = {
          uuid: this.groupData.uuid
        }
        this.loading = getLoading()
        const res = await deleteGroup(data).finally(() => {
          this.loading.close()
        })
        if (res.ok) {
          this.disabled = true
          this.deleteShow = true
          this.$message.success(this.$t('BusinessIntelligence.chartGroupSetting.deleteSuccess'))
          this.getList()
        }
      }
      // 删除图表
      if (Object.keys(this.chartData).length !== 0) {
        const data = {
          groupUuid: '',
          chartId: this.chartData.chartId
        }
        this.loading = getLoading()
        const res = await editChart(data).finally(() => {
          this.loading.close()
        })
        if (res.ok) {
          await this.getList()
          this.disabled = true
          this.deleteShow = true
          this.editChartShow = false
          this.$message.success(this.$t('BusinessIntelligence.chartGroupSetting.deleteSuccess'))
        }
      }
    },
    // 图表编辑取消取消
    editChartCancel() {
      this.editName = false
      this.isCheck = true
      this.chartForm = {
        name: this.chartData.name,
        groupUuid: this.chartData.groupUuid,
        chartId: this.chartData.chartId,
        remark: this.chartData.remark
      }
    },
    // 分组编辑取消按钮
    editCancel() {
      this.editGroupingShow = false
      this.editChartShow = true
      this.isCheck = true
      this.editName = false
      this.chartList = []
      this.form = {
        rankIndex: '',
        name: '',
        remark: '',
        charts: []
      }
      this.searchValue = ''
    }
  }
}
</script>
<style lang="scss">
.chart-group-setting{
  display: flex;
  flex-direction: row !important;
  .setting-left{
    width: 250px;
    margin-top: 10px;
    background-color: #fff;
    overflow-y:auto;
    .el-icon-arrow-right {
      order: -1;
      margin:0 10px 0 0;
    }
    .el-collapse-item__content{
      padding: 0;
    }
    .el-collapse-item__header{
      padding-left: 20px;
      &:hover {
        background: #ecf5ff;
        color: #409eff;
      }
    }
    .chart-item{
      cursor: pointer;
      height: 45px;
      line-height: 45px;
      padding-left: 60px;
      &:hover {
        background: #ecf5ff;
        color: #409eff;
      }
    }
  }
  .setting-right{
    display: flex;
    flex-direction: column;
    width:70%;
    margin: 10px 0 0 10px;
    .setting-right-operation{
      height: 40px;
      width: 100%;
      border-bottom:1px solid #fff;
    }
    .setting-right-content{
      flex: 1;
      .edit-button{
        margin-top: 10px;
      }
      .ag-form{
        background: #fff;
        padding: 10px;
        box-sizing: border-box;
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-top:10px;
        .title{
          display: inline-block;
          width: 100%;
          font-size: 18px;
          height: 35px;
          border-bottom: 1px solid #ccc;
          line-height: 35px;
          box-sizing: border;
        }
        .ag-form-content{
          flex: 1;
          display: flex;
          margin-top: 10px;
          .edit-form{
            display: flex;
            flex-direction: column;
            width: 250px;
          }
          .chart-form{
            display: flex;
            margin-left: 20px;
            width: 60%;
            flex-direction: column;
            .chart{
              margin-top:10px;
              flex:1;
              position: relative;
              .mask{
                position: absolute;
                bottom: 0px;
                left:0;
                width:100%;
                height:45px;
                background-color: #fff;
              }
            }
            .chart-form-search{
              display: flex;
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
  .setColor{
    background: #ecf5ff;
    color: #409eff;
  }
  .nav-list{
    min-height: 48px;
    display: flex;
    align-items: center;
    width: 100%;
    flex-direction: column;
    color: #333333;
    cursor: pointer;
    font-size: 13px;
    box-sizing: border-box;
    .item{
      width: 100%;
      height: 48px;
      line-height: 48px;
      padding-left:20px;
      box-sizing: border-box;
      border-bottom: 1px solid #ebeef5;
    }
    .children-item{
      width: 100%;
      display: flex;
      flex-direction: column;
      span{
        width: 100%;
        height: 48px;
        line-height: 48px;
        padding-left:60px;
        &:hover{
          background: #ecf5ff;
          color: #409eff;
        }
      }
    }
    .border-bottom{
      border-bottom: 1px solid #ebeef5;
    }
  }
  .rotatingShow{
    transform: rotate(90deg);
    transition: all 0.2s ease 0s;
  }
  .rotatingHide{
    transform: rotate(0deg);
    transition: all 0.2s ease 0s;
  }
  .set-input{
    height:28px;
    border: 1px solid #DCDFE6;
    text-indent: 6px;
    font-size:12px;
    &:focus{
      outline-style: none;
      border: 1px solid #226cc1;
      border-radius: 1px;
    }
  }
}
</style>
